<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="element-box">
        <CoachingOverviewData :coaching="coachingData"/>
        <Menu :currentUser=piniaCurrentUser
              :coaching="coachingData"/>

        <transition name="fade">
          <div class="row" v-if="unitsErrorMessage">
            <div class="col-12">
              <div style="
                color: #e65252;
                font-size: 16px;
                padding: 10px;
                background: #F8F8F8;
                border: 1px solid #e65252;
                margin-bottom: 20px;
                border-radius: 3px">
                {{ unitsErrorMessage }}
              </div>
            </div>
          </div>
        </transition>

        <div v-if="showUpdateAsAdminButton" class="row mb-5" style="border-bottom: 1px solid #D8D8D8">
          <div class="col text-right" style="font-size: 17px;">{{ $t('general.update_as_admin') }}</div>
          <div class="col-auto text-right">
            <BaseToggle v-model="updateAsAdmin" @change="onChangeUpdateAsAdmin"/>
          </div>
        </div>

        <form @submit.prevent="submitForm" novalidate class="mt-4">
          <div class="row">
            <div class="col-lg-2 col-md-4 col-sm-6 col-12  ">
              <Datepicker
                  v-model="formData.termin"
                  :disabled="isBilled || isCoachBilled"
                  :required="true"
                  label="Termin"
                  position="down"
                  :validation="v$.termin"
                  :messages="v$.termin.required.$message"/>
            </div>
            <div class="col-lg-4 col-md-8 col-sm-12  ">
              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                  <Timepicker
                      v-model="formData.startTime"
                      :key="startTimeKey"
                      :disabled="isBilled || isCoachBilled"
                      :required="true"
                      :minutesArray='["00", "05", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55"]'
                      label="Startzeit"
                      @update:modelValue="calculateTimeDifference"/>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                  <Timepicker
                      v-model="formData.endTime"
                      :key="endTimeKey"
                      :disabled="isBilled || isCoachBilled"
                      :required="true"
                      :minutesArray='["00", "05", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55"]'
                      label="Endzeit"
                      @update:modelValue="calculateTimeDifference"/>
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12">
              <SelectVue v-model="formData.presence"
                         :options="presenceDropdown"
                         :disabled="isBilled || isCoachBilled"
                         :required="true"
                         label="Anwesenheit"
                         placeholder="Wählen Sie Anwesenheit"
                         :validation="v$.presence"
                         :messages="v$.presence.required.$message"
                         @update:modelValue="calculateTimeDifference"/>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12">
              <BaseCheckbox
                  v-model="formData.overwrite"
                  :disabled="isBilled || isCoachBilled"
                  label="Überschreiben"
                  @update:modelValue="calculateTimeDifference"/>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12">
              <BaseNumber
                  v-model="formData.units"
                  label="Einheiten"
                  disabled="disabled"/>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12">
              <SelectVue v-model="formData.coachType"
                         :disabled="isBilled || isCoachBilled"
                         :options="coachTypeDropdown"
                         :required="true"
                         :is-clear="true"
                         label="Coachart"
                         placeholder="Wählen Sie Coachart"
                         :validation="v$.coachType"
                         :messages="v$.coachType.required.$message"/>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12">
              <div class="mt-4">
                <BaseCheckbox
                    v-model="formData.signature"
                    :disabled="isBilled || isCoachBilled || isDigitalSignature"
                    label="Unterschrift"
                    :labelPosition="'right'"/>
              </div>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12" v-if="currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT'">
              <div class="mt-4">
                <BaseCheckbox
                    v-model="formData.billed"
                    :disabled="isBilled || isCoachBilled"
                    label="Abgerechnet"
                    :labelPosition="'right'"/>
              </div>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12" v-if="currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT'">
              <div class=" mt-4">
                <BaseCheckbox
                    v-model="formData.paid"
                    :disabled="isBilled || isCoachBilled"
                    label="Bezahlt"
                    :labelPosition="'right'"/>
              </div>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12">
              <div class="mt-4" v-if="operationType === 'sociotherapie'">
                <BaseCheckbox
                    v-model="formData.homeVisit"
                    :disabled="isBilled || isCoachBilled"
                    label="Hausbesuch"
                    :labelPosition="'right'"/>
              </div>
            </div>
          </div>

          <div class="row mt-3 pt-3" style="border-top: 1px solid #ddd">
            <div class="col-lg-4 col-md-6 col-sm-12">
              <SelectVue v-model="formData.meetingType"
                         :options="meetingTypeDropdown"
                         :disabled="isBilled || isCoachBilled"
                         :is-clear="true"
                         label="Art des Termins"
                         placeholder="Wählen Sie Art des Termins"
                         :validation="v$.meetingType"
                         :messages="v$.meetingType.required.$message"
                         @update:modelValue="calculateTimeDifference"/>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12"
                 v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' ||
                  currentUserRole === 'ROLE_ACCOUNTANT'">
              <SelectVue v-model="formData.coachId"
                         :disabled="isCoachBilled"
                         :options="coachDropdown"
                         :is-clear="true"
                         label="Coach"
                         placeholder="Trainer auswählen"/>
            </div>
          </div>

          <div class="row mt-3 pt-3" style="border-top: 1px solid #ddd">
            <div class="col-lg-6 col-md-12 col-sm-12">
              <SelectVue v-model="formData.contentOfMeasure"
                         :options="contentOfMeasureDropdown"
                         :is-clear="true"
                         :is-multi="true"
                         label="Ziel/ Inhalt der Maßnahme"/>
            </div>
            <div v-if="operationType === 'sociotherapie'" class="col-lg-6 col-md-12 col-sm-12">
              <SelectVue v-model="formData.peopleInvolved"
                         :options="peopleInvolvedDropdown"
                         :is-clear="true"
                         :is-multi="true"
                         label="Beteiligte Personen (P/T /+ weitere)"/>
            </div>
          </div>

          <div class="row">
            <div class="col-12 text-right">
              <button
                  v-if="currentUserRole === 'ROLE_ADMIN' && updatedByAdmin"
                  @click.prevent="handleMeetingHistoryModal()"
                  class="btn btn-primary" style="margin-top: 28px;">
                <i class="os-icon os-icon-rotate-ccw"></i>
              </button>

              <button v-if="isDigitalSignature && firstInterviewId" class="btn btn-primary" style="margin-top: 28px;"
                      @click.prevent="handleDigitalSignatureModal()">
                Digitale Unterschrift
              </button>

              <span v-if="isDigitalSignature && missingDigitalSignatureForFirstInterview"
                    style="color: red; display: block; margin-top: 11px;">
                {{ $t('general.missing_digital_signature') }}
              </span>
            </div>
          </div>

          <div class="accordion mt-5">
            <!-- Accordion Item 1 -->
            <div class="accordion-item">
              <div class="accordion-header" @click="toggleAccordion(1)">
                <h6 :style="{ color: 'var(--primary)' }">Gesundheitsfragen</h6>
              </div>
              <div v-if="activeAccordion === 1" class="accordion-body">
                <AccordionItem
                    title="Einschränkung"
                    :items="formData.limitations"
                    itemTitleLabel="Gesundheitliche Einschränkung"
                    itemDescriptionLabel="Auswirkung"
                    @addItem="(newItem) => addItem('limitations', newItem)"
                    @deleteItem="(index) => removeItem('limitations', index)"/>
                <AccordionItem
                    title="Abhängigkeit"
                    :items="formData.dependencies"
                    itemTitleLabel="Art der Abhängigkeit"
                    itemDescriptionLabel="Beschreibung (Menge/Substanz)"
                    @addItem="(newItem) => addItem('dependencies', newItem)"
                    @deleteItem="(index) => removeItem('dependencies', index)"/>
                <AccordionItemWithDropdown
                    title="Ärztliche Versorgung"
                    :items="formData.medicalCares"
                    itemTitleLabel="Arzt"
                    itemDescriptionLabel="Kontaktdaten"
                    :dropdownOptions="doctorTypeDropdown"
                    @addItem="(newItem) => addItem('medicalCares', newItem)"
                    @deleteItem="(index) => removeItem('medicalCares', index)"/>
                <AccordionItem
                    title="Medikamente"
                    :items="formData.medications"
                    itemTitleLabel="Handelsname"
                    itemDescriptionLabel="Indikation"
                    @addItem="(newItem) => addItem('medications', newItem)"
                    @deleteItem="(index) => removeItem('medications', index)"/>
                <AccordionItemWithDropdown
                    title="Weitere ambulante Behandlung und Hilfeleistung"
                    :items="formData.treatmentsAndAssistance"
                    itemTitleLabel="Art der Hilfeleistung"
                    itemDescriptionLabel="Kontaktdaten"
                    :dropdownOptions="assistanceTypeDropdown"
                    @addItem="(newItem) => addItem('treatmentsAndAssistance', newItem)"
                    @deleteItem="(index) => removeItem('treatmentsAndAssistance', index)"/>
                <AccordionItem
                    title="Stationäre Behandlung der letzten Jahre"
                    :items="formData.treatmentInYears"
                    itemTitleLabel="Krankenhaus"
                    itemDescriptionLabel="Beschreibung / Folgen"
                    @addItem="(newItem) => addItem('treatmentInYears', newItem)"
                    @deleteItem="(index) => removeItem('treatmentInYears', index)"/>
                <AccordionItem
                    title="wichtige Kontakte"
                    :items="formData.importantContacts"
                    itemTitleLabel="Person"
                    itemDescriptionLabel="Erläuterung/Kontaktdaten"
                    @addItem="(newItem) => addItem('importantContacts', newItem)"
                    @deleteItem="(index) => removeItem('importantContacts', index)"/>
              </div>
            </div>

            <!-- Accordion Item 2 -->
            <div class="accordion-item">
              <div class="accordion-header" @click="toggleAccordion(2)">
                <h6 :style="{ color: 'var(--primary)' }">Ressourcen und Kompetenzen</h6>
              </div>
              <div v-if="activeAccordion === 2" class="accordion-body">
                <AccordionItem
                    title="Ressourcen und Kompetenzen"
                    :items="formData.resourceAndSkills"
                    itemTitleLabel="Ressourcen und Kompetenzen"
                    itemDescriptionLabel="Was und wie?"
                    @addItem="(newItem) => addItem('resourceAndSkills', newItem)"
                    @deleteItem="(index) => removeItem('resourceAndSkills', index)"/>
                <AccordionItem
                    title="Ist-Zustand bei Aufnahme"
                    :items="formData.actualConditions"
                    itemTitleLabel="Ziele"
                    itemDescriptionLabel="Soll"
                    @addItem="(newItem) => addItem('actualConditions', newItem)"
                    @deleteItem="(index) => removeItem('actualConditions', index)"/>
                <AccordionItem
                    title="Ist-Zustand nach 2.VO"
                    :items="formData.actualStates"
                    itemTitleLabel="Ziele"
                    itemDescriptionLabel="Soll"
                    @addItem="(newItem) => addItem('actualStates', newItem)"
                    @deleteItem="(index) => removeItem('actualStates', index)"/>
              </div>
            </div>

            <!-- Accordion Item 3 -->
            <div class="accordion-item">
              <div class="accordion-header" @click="toggleAccordion(3)">
                <h6 :style="{ color: 'var(--primary)' }">Einschränkung</h6>
              </div>
              <div v-if="activeAccordion === 3" class="accordion-body">
                <AccordionItem
                    title="Einschränkung"
                    :items="formData.obstacles"
                    itemTitleLabel="Problemlage / Hemmnis"
                    itemDescriptionLabel="Beschreibung"
                    @addItem="(newItem) => addItem('obstacles', newItem)"
                    @deleteItem="(index) => removeItem('obstacles', index)"/>
                <AccordionItem
                    title="Handlungsplan"
                    :items="formData.steps"
                    itemTitleLabel="Ziel"
                    itemDescriptionLabel="Umsetzung"
                    @addItem="(newItem) => addItem('steps', newItem)"
                    @deleteItem="(index) => removeItem('steps', index)"/>
                <AccordionItemWithDropdown
                    title="Coaching"
                    :items="formData.typesOfCoaching"
                    itemTitleLabel="Art des Coachings"
                    :dropdownOptions="typesOfCoachingDropdown"
                    itemDescriptionLabel="Beschreibung"
                    itemSelectPlaceholder="Coachingarten"
                    @addItem="(newItem) => addItem('typesOfCoaching', newItem)"
                    @deleteItem="(index) => removeItem('typesOfCoaching', index)"/>
              </div>
            </div>
          </div>

          <ValidationErrorMessage :validationErrors=v$?.$errors></ValidationErrorMessage>

          <div v-if="!unitsErrorMessage" class="d-flex justify-content-center w-100 mt-5">
            <SaveButton
                :label="$t('general.button.save')"
                :loading="isSubmitting"/>
          </div>
        </form>
      </div>
    </div>
  </PageTemplate>

  <Modal
      v-model="showDigitalSignatureModal"
      title="Digitale Unterschrift"
      :hide-cancel="true"
      :button-label="$t('general.button.save')"
      sizeModal="modal-md"
      :hide-footer="true"
      classFooter="justify-content-center">
    <SocioTherapyCoachingDigitalSignatureForm
        :meetingId="firstInterviewId"
        :coachingId="coachingId"
        meetingType="firstInterview"
        v-model:missingDigitalSignature="missingDigitalSignatureForFirstInterview"
        v-model:submitForm="digitalSignatureSubmitForm"/>
  </Modal>

  <Modal
      title="Begegnungsgeschichte"
      :button-label="$t('general.button.save')"
      :customWidth="'1400px'"
      v-model="showMeetingHistoryModal"
      :hide-footer="true"
      classFooter="justify-content-center">
    <MeetingHistoryList :meetingId="firstInterviewId"/>
  </Modal>
</template>

<script setup>
import portalSocioTherapyCoachingService from '@/api/Portal/SocioTherapyCoaching';
import socioTherapyCoachingService from '@/api/Unemployed/SocioTherapyCoaching';
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import BaseNumber from '@/components/base/BaseNumber.vue';
import Loader from '@/components/Loader.vue';
import Modal from '@/components/modal/Modal.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import Timepicker from '@/components/picker/Timepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import ValidationErrorMessage from '@/components/ValidationErrorMessage.vue';
import { CloseToast, ErrorToast, SuccessToast } from '@/components/VueToast';
import { addDeletedCoachToDropdown } from '@/shared/portal/commonFunctions';
import { requiredRule } from '@/shared/validators/validationRules';
import { piniaEnumsStore } from '@/store/piniaEnumsStore';
import { piniaUserStore } from '@/store/piniaUserStore';
import CoachingOverviewData from '@/views/App/Portal/SocioTherapyCoaching/CoachingOverviewData.vue';
import AccordionItem from '@/views/App/Portal/SocioTherapyCoaching/FirstInterview/AccordionItem.vue';
import AccordionItemWithDropdown
  from '@/views/App/Portal/SocioTherapyCoaching/FirstInterview/AccordionItemWithDropdown.vue';
import Menu from '@/views/App/Portal/SocioTherapyCoaching/Menu.vue';
import SocioTherapyCoachingDigitalSignatureForm
  from '@/views/App/Portal/SocioTherapyCoaching/SocioTherapyCoachingDigitalSignatureForm.vue';
import useVuelidate from '@vuelidate/core';
import { computed, onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import BaseToggle from "@/components/base/BaseToggle.vue";
import MeetingHistoryList from "@/views/App/Portal/SocioTherapyCoaching/MeetingHistoryList.vue";
import SaveButton from '@/components/button/SaveButton.vue';

const piniaUserState                           = piniaUserStore();
const piniaCurrentUser                         = computed(() => piniaUserState.currentUser.user);
const currentUserRole                          = piniaCurrentUser.value.roles[ 0 ];
const piniaEnumsState                          = piniaEnumsStore();
const getEnums                                 = computed(() => piniaEnumsState.enums);
const { t }                                    = useI18n();
const coachingData                             = ref('');
const route                                    = useRoute();
const coachingId                               = route.params.id;
const firstInterviewId                         = ref(null);
const operationType                            = ref('');
const presenceDropdown                         = ref([]);
const coachTypeDropdown                        = ref([]);
const meetingTypeDropdown                      = ref([]);
const contentOfMeasureDropdown                 = ref([]);
const peopleInvolvedDropdown                   = ref([]);
const coachDropdown                            = ref([]);
const doctorTypeDropdown                       = ref([]);
const assistanceTypeDropdown                   = ref([]);
const graduationTypeDropdown                   = ref([]);
const meetingType1Enums                        = ref([]);
const meetingType2Enums                        = ref([]);
const typesOfCoachingDropdown                  = ref([]);
const unitsErrorMessage                        = ref('');
const isDigitalSignature                       = ref(false);
const showDigitalSignatureModal                = ref(false);
const digitalSignatureSubmitForm               = ref(false);
const isLoaded                                 = ref(false);
const isSubmitting                             = ref(false);
const isBilled                                 = ref(false);
const isCoachBilled                            = ref(false);
const activeAccordion                          = ref(null); // Tracks the currently open accordion item
const missingDigitalSignatureForFirstInterview = ref(false);

const updateAsAdmin = ref(false) // Need this for update as admin logic
const updatedByAdmin = ref(false) // Need this for update as admin logic
const originalIsBilled = ref(false); // Need this for update as admin logic
const originalIsCoachBilled = ref(false); // Need this for update as admin logic;
const showMeetingHistoryModal = ref(false);

const formData = ref({
  coachingId: '',
  operationType: '',
  termin: '',
  startTime: '00:00',
  endTime: '00:00',
  presence: '',
  coachType: '',
  meetingType: '',
  overwrite: false,
  units: 0,
  signature: false,
  billed: false,
  paid: false,
  homeVisit: false,
  coachId: null,
  contentOfMeasure: [],
  peopleInvolved: [],

  // Accordion 1
  limitations: [],
  dependencies: [],
  medicalCares: [],
  medications: [],
  treatmentsAndAssistance: [],
  treatmentInYears: [],
  importantContacts: [],

  // Accordion 2
  resourceAndSkills: [],
  actualConditions: [],
  actualStates: [],

  // Accordion 3
  obstacles: [],
  steps: [],
  typesOfCoaching: [],
});

const originalFormData = ref({});
// This key will force the Timepicker to re-create when changed
const startTimeKey = ref(formData.value.startTime);
const endTimeKey = ref(formData.value.endTime);

const formRules = ref({
  termin: requiredRule(t),
  startTime: requiredRule(t),
  endTime: requiredRule(t),
  presence: requiredRule(t),
  coachType: requiredRule(t),
  meetingType: requiredRule(t),
  overwrite: requiredRule(t),
  units: requiredRule(t),
  signature: requiredRule(t),
  billed: requiredRule(t),
  paid: requiredRule(t),
  homeVisit: requiredRule(t),
});

const computedRules = computed(() => formRules.value);
const v$            = useVuelidate(computedRules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    formData.value.coachingId    = +coachingId;
    formData.value.operationType = operationType.value;
    formData.value.units         = Number(formData.value.units);// or parseFloat if you prefer

    if (firstInterviewId.value) {
      if (updateAsAdmin.value) {
        await portalSocioTherapyCoachingService.updateFirstInterviewAsAdmin(
            formData.value,
            +firstInterviewId.value
        );
      } else {
        await portalSocioTherapyCoachingService.updateFirstInterview(
            formData.value,
            +firstInterviewId.value
        );
      }
    } else {
      await portalSocioTherapyCoachingService.createFirstInterview(
          formData.value
      );
    }

    await getSocioTherapyCoachingData(coachingId); // This must be first because of coach dropdown
    await getFirstInterviewData(coachingId);

    activeAccordion.value = null;
    updateAsAdmin.value = false;
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getSocioTherapyCoachingData() {
  try {
    CloseToast();
    const { data }           = await socioTherapyCoachingService.getSocioTherapyCoaching(+coachingId);
    operationType.value      = data?.data?.operationType;
    coachingData.value       = data?.data;
    isDigitalSignature.value = data.data.digitalSignature;

    const coach = data.data?.coach;

    coachDropdown.value = [
      {
        label: `${coach.firstName} ${coach.lastName}`,
        value: coach.id,
      },
    ];
  } catch (error) {
    await ErrorToast(error);
  }
}

async function getFirstInterviewData() {

  const { data } = await portalSocioTherapyCoachingService.getFirstInterviewData(coachingId);

  const firstInterview = data.data;

  if (firstInterview) {
    isBilled.value      = data?.data?.invoiced;
    isCoachBilled.value = data?.data?.coachInvoiced;

    // Save original values
    originalIsBilled.value = firstInterview.invoiced;
    originalIsCoachBilled.value = firstInterview.coachInvoiced;
    updatedByAdmin.value = firstInterview.updatedByAdmin

    if (!firstInterview.digitalSignatureImage) {
      missingDigitalSignatureForFirstInterview.value = true;
    }

    const coachId                     = firstInterview?.coach?.id;
    const limitationsData             = mapData(firstInterview?.limitations || []);
    const dependenciesData            = mapData(firstInterview?.dependencies || []);
    const medicalCaresData            = mapData(firstInterview?.medicalCares || []);
    const medicationsData             = mapData(firstInterview?.medications || []);
    const treatmentsAndAssistanceData = mapData(firstInterview?.treatmentsAndAssistance || []);
    const treatmentInYearsData        = mapData(firstInterview?.treatmentInYears || []);
    const importantContacts           = mapData(firstInterview?.importantContacts || []);
    const resourceAndSkillsData       = mapData(firstInterview?.resourceAndSkills || []);
    const actualConditions            = mapData(firstInterview?.actualConditions || []);
    const actualStates                = mapData(firstInterview?.actualStates || []);
    const obstaclesData               = mapData(firstInterview?.obstacles || []);
    const stepsData                   = mapData(firstInterview?.steps || []);
    const typesOfCoachingData         = mapData(firstInterview?.typesOfCoaching || []);
    const meetingType                 = firstInterview?.meetingType;

    addDeletedCoachToDropdown(firstInterview.coach, coachDropdown);

    firstInterviewId.value = firstInterview?.id;

    // On creates only anwesend, unentschuldigt for both types !!!!
    // On edit, we need to show selected presence if it is not one of these two types
    const currentPresence            = firstInterview.presence;
    const currentPresenceTranslation = firstInterview.presenceTranslation;
    if (currentPresence === 'krank' || currentPresence === 'entschuldigt') {
      presenceDropdown.value.push({
        value: currentPresence,
        label: currentPresenceTranslation,
      });
    }

    // Coach type dropdown
    // On creation only soziotherapie for both types !!!
    // On edit, we need to show selected value if it is not soziotherapie
    const currentCoachType            = firstInterview.coachType;
    const currentCoachTypeTranslation = firstInterview.coachTypeTranslation;
    if (currentCoachType !== null && !coachTypeDropdown.value.includes(currentCoachType)) {
      coachTypeDropdown.value.push({
        value: currentCoachType,
        label: currentCoachTypeTranslation,
      });
    }

    // Meeting type dropdown
    // On edit, we need to add 'initial_consultation' if is selected
    const currentMeetingType = firstInterview.meetingType;
    if (operationType.value === 'sociotherapie') {
      if (firstInterviewId.value !== null && firstInterviewId.value !== '') {
        if (currentMeetingType === 'initial_consultation') {
          meetingType2Enums.value.push(currentMeetingType);
        }
      }
    }

    formData.value = {
      ...formData.value,
      ...firstInterview,
      coachId: coachId,
      limitations: limitationsData,
      dependencies: dependenciesData,
      medicalCares: medicalCaresData,
      medications: medicationsData,
      treatmentsAndAssistance: treatmentsAndAssistanceData,
      treatmentInYears: treatmentInYearsData,
      importantContacts: importantContacts,
      resourceAndSkills: resourceAndSkillsData,
      actualConditions: actualConditions,
      actualStates: actualStates,
      obstacles: obstaclesData,
      steps: stepsData,
      typesOfCoaching: typesOfCoachingData,
      meetingType: meetingType,
    };

    // store original as a deep copy !!!
    originalFormData.value = JSON.parse(JSON.stringify(formData.value));
  }

}

// Accordion
const toggleAccordion = (index) => {
  activeAccordion.value = activeAccordion.value === index ? null : index;
};

const addItem = (type, newItem) => {
  formData.value[ type ].push(newItem);
};

const removeItem = (type, index) => {
  formData.value[ type ].splice(index, 1);
};

const calculateTimeDifference = () => {
  if (formData.value.startTime && formData.value.endTime) {
    const [ startHours, startMinutes ] = formData.value.startTime.split(':').map(Number);
    const [ endHours, endMinutes ]     = formData.value.endTime.split(':').map(Number);
    const startTotalMinutes            = startHours * 60 + startMinutes;
    const endTotalMinutes              = endHours * 60 + endMinutes;
    const diffMinutes                  = endTotalMinutes - startTotalMinutes;
    const meetingType                  = formData.value.meetingType;
    const unitDuration                 = 50;
    let units                          = (diffMinutes / 50).toPrecision(3).substring(0, 4);
    units                              = parseFloat(units);

    onChangeUnits(units);

    // Check a presence type
    if ((formData.value.presence)) {
      if (formData.value.presence === 'anwesend') {
        units = (diffMinutes / unitDuration).toPrecision(3).substring(0, 4);
      } else {
        units = 1;
      }
    }

    // If presenceType is selected and overview is true, calculate units
    if (formData.value.overwrite === true) {
      units = (diffMinutes / unitDuration).toPrecision(3).substring(0, 4);
    }

    if (units > 0 && meetingType) {
      onChangeMeetingType(units);
    }

    formData.value.units = Number(units).toFixed(2);
  } else {
    formData.value.units = 0;
  }
};

function onChangeUnits(value) {
  // Parse value to a float
  const parsedValue = parseFloat(value);

  if (isNaN(parsedValue) || parsedValue <= 0) {
    unitsErrorMessage.value = 'Einheiten müssen runde Zahlen sein, die größer als 0 sind.';
  } else {
    unitsErrorMessage.value = '';
  }
}

function onChangeMeetingType(units) {
  // SOCIO THERAPY
  if (operationType.value === 'sociotherapie') {
    let fullMeetingHours = units * 50; // Important !!!

    if (formData.value.meetingType === 'trial_lesson') { // meeting must be a full unit !!!!!
      if (units !== 1) {
        if ((fullMeetingHours !== 0) && (fullMeetingHours % 50 === 0)) {
          unitsErrorMessage.value = '';
        } else {
          unitsErrorMessage.value = 'Probestunden müssen in vollen Einheiten angerechnet werden. ' +
              'Bitte passe deinen Eintrag an.';
        }
      }
    } else {
      if (fullMeetingHours % 10 === 0 || fullMeetingHours % 25 === 0) { // increase in interval 10 or 25 minutes
        unitsErrorMessage.value = '';
      } else {
        unitsErrorMessage.value = 'Termine können nur in 10/25 Minuten Taktung abgerechnet werden, ' +
            'daher muss dein gewähltes Zeitfenster bitte angepasst werden.';
      }
    }
  } else { //SOCIO THERAPY PRIMARY TYPE
    // Multiplying meetingHours by 10 could be a way to avoid working with fractional values
    // (e.g., 1.5 hours become 15).
    let fullMeetingHours = units * 10;
    if (fullMeetingHours % 5 === 0) {
      unitsErrorMessage.value = '';
    } else {
      unitsErrorMessage.value = 'Termine können nur in 25/50 Minuten Taktung abgerechnet werden, ' +
          'daher muss dein gewähltes Zeitfenster bitte angepasst werden.';
    }
  }
}

function handleDigitalSignatureModal() {
  CloseToast();
  showDigitalSignatureModal.value = true;
}

//watch(
//    () => [
//      formData.value.startTime,
//      formData.value.endTime,
//      formData.value.presence,
//      formData.value.overwrite,
//      formData.value.meetingType,
//    ],
//    calculateTimeDifference,
//);

async function getEnumsDropdown() {

  // 1. PRESENCE DROPDOWN
  // On creates only anwesend, unentschuldigt for both type !!!!
  const allowedPresences = [ 'anwesend', 'unentschuldigt' ];
  presenceDropdown.value = (getEnums?.value?.presenceTypes || []).filter(item =>
      allowedPresences.includes(item.value),
  );

  // 2. COACH TYPE DROPDOWN !!!
  // On creation only soziotherapie for both type !!!
  coachTypeDropdown.value = (getEnums?.value?.portalCoachTypes || []).filter(
      item => item.value === 'soziotherapie',
  );

  // 3. MEETING TYPE DROPDOWN !!!
  // For operationType 'sociotherapie' we have only two types on creation (trial_lesson, sociotherapy)
  if (operationType.value === 'sociotherapie') {
    const allowedMeetingTypes2 = [ 'trial_lesson', 'sociotherapy' ];
    meetingType2Enums.value    = (getEnums?.value?.socioTherapyMeetingTypes2 || []).filter(item =>
        allowedMeetingTypes2.includes(item.value),
    );
  }

  // For operationType 'sociotherapie_primary' we take all from enums
  if (operationType.value === 'sociotherapie_primary') {
    meetingType1Enums.value = getEnums?.value?.socioTherapyMeetingTypes || [];
  }

  doctorTypeDropdown.value       = getEnums?.value?.doctorTypes || [];
  assistanceTypeDropdown.value   = getEnums?.value?.assistanceTypes || [];
  graduationTypeDropdown.value   = getEnums?.value?.graduationTypes || [];
  contentOfMeasureDropdown.value = getEnums?.value?.contentOfMeasures || [];
  peopleInvolvedDropdown.value   = getEnums?.value?.peopleInvolved || [];
  typesOfCoachingDropdown.value  = getEnums?.value?.typesOfCoaching || [];

}

const mapData = (data, fields = [ 'id', 'title', 'description' ]) => {
  return data.map(item => {
    let mappedItem = {};
    fields.forEach(field => {
      mappedItem[ field ] = item[ field ] ?? null;
    });
    return mappedItem;
  });
};

watch(formData, () => {
  if (!formData.value.contentOfMeasure.includes(1)) {
    formData.value.contentOfMeasure.push(1);
  }

  if (operationType.value === 'sociotherapie') {
    if (!formData.value.peopleInvolved.includes('patient')) {
      formData.value.peopleInvolved.push('patient');
    }
  }
}, { deep: true });

watch(digitalSignatureSubmitForm, () => {
  showDigitalSignatureModal.value = false;
});


function onChangeUpdateAsAdmin() {
  if (updateAsAdmin.value) {
    isBilled.value = false;
    isCoachBilled.value = false;
  } else {
    // restore form data from original snapshot
    formData.value = JSON.parse(JSON.stringify(originalFormData.value));

    formData.value.startTime = originalFormData.value.startTime;
    startTimeKey.value = originalFormData.value.startTime + '_' + Date.now(); // Change the key to force re-render

    formData.value.endTime = originalFormData.value.endTime;
    endTimeKey.value = originalFormData.value.endTime + '_' + Date.now(); // Change the key to force re-render

    isBilled.value = originalIsBilled.value;
    isCoachBilled.value = originalIsCoachBilled.value;
  }
}

const showUpdateAsAdminButton = computed(() =>
    (currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT') &&
    (originalIsBilled.value || originalIsCoachBilled.value)
);

function handleMeetingHistoryModal() {
  CloseToast();
  showMeetingHistoryModal.value = true;
  showDigitalSignatureModal.value = false;
}

onMounted(async () => {
  CloseToast();

  // This is important.
  // This needs to be loaded first because of an operation type
  await Promise.all([
    await getSocioTherapyCoachingData(),
    await getEnumsDropdown(),
  ]);

  await getFirstInterviewData();

  // Important !!!!
  if (operationType.value === 'sociotherapie') {
    meetingTypeDropdown.value = meetingType2Enums.value;
  } else {
    meetingTypeDropdown.value = meetingType1Enums.value;
  }
  isLoaded.value = true;
});
</script>

<style scoped>
</style>